import { useLingui } from '@lingui/react/macro';

import { Badge } from '@rover/kibble/official-patterns/Badge';

import { PhotoRelationship } from './ImageGallery.common';

type Props = {
  relationship: PhotoRelationship;
};

const OwnershipTag = ({ relationship }: Props): JSX.Element => {
  const { t } = useLingui();
  const text = relationship === PhotoRelationship.Contributor ? t`Your photo` : t`Your pet`;

  return <Badge boxProps={{ testID: 'gallery-ownership-tag' }} text={text} />;
};

export default OwnershipTag;
